import { inject, Injectable } from '@angular/core';
import { InvoiceClient, InvoiceStatusEnum, InvoiceViewModel, UpcomingInvoicePreviewModel } from '@rma/billing-api';
import { BillingUserContextService } from '@rma/dashboard/authentication/public/user';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { cache } from 'decorator-cache-getter';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private readonly billingUserContextService = inject(BillingUserContextService);
  private readonly invoiceClient = inject(InvoiceClient);

  private readonly validInvoiceStatuses = [InvoiceStatusEnum.Open, InvoiceStatusEnum.Paid];

  @cache
  public get upcomingInvoice$(): Observable<UpcomingInvoicePreviewModel> {
    return this.billingUserContextService.userContext$.pipe(
      switchMap((context) => this.invoiceClient.getUpcomingInvoice(context.productUserType, context.productUserGroupingType, context.code)),
      rmaShareReplay(),
    );
  }

  @cache
  public get invoices$(): Observable<InvoiceViewModel[]> {
    return this.billingUserContextService.userContext$.pipe(
      switchMap((context) =>
        this.invoiceClient.getInvoices(this.validInvoiceStatuses, context.productUserType, context.productUserGroupingType, context.code),
      ),
      rmaShareReplay(),
    );
  }
}
